import React, { useState } from "react";
import styled from "styled-components";
import { Spacer } from "../common/Spacer";
import { HistoryOutlined } from "@ant-design/icons";
import { ExitTemporaryUserModal } from "views/components/common/TemporaryUserPopUp";
import { useLogoutWithTemporaryUser } from "hooks/useLogoutWithTemporaryUser";

export const TemporaryUserInfo = ({ isLoggedInTemporary, desktop }) => {
	const [showExitModal, setShowExitModal] = useState(false);
	const { actionWithTemporary } = useLogoutWithTemporaryUser();
	const [buttonType, setButtonType] = useState("");

	const logInWithRealUser = (type) => {
		actionWithTemporary(type);
		setShowExitModal(false);
	};
	const openExitModal = (type) => {
		setShowExitModal(true);
		setButtonType(type);
	};
	return (
		<div>
			{showExitModal && (
				<ExitTemporaryUserModal
					setShowExitModal={setShowExitModal}
					logInWithRealUser={logInWithRealUser}
					buttonType={buttonType}
					desktop={desktop}
				/>
			)}
			<HeaderTemporary>
				<Avatar isLoggedInTemporary={isLoggedInTemporary}>
					<HistoryOutlined style={{ fontSize: 38, color: "#fff" }} />
				</Avatar>
				<Spacer rows={0.5} />
				<span>{"Ingresaste como usuario temporal"}</span>
				<Spacer rows={1} />
				<div style={{ textAlign: "center" }}>
					<p>
						<span style={{ fontWeight: "bold" }}>
							¡Mejora tu experiencia!,{" "}
						</span>
						para acceder al historial, sucursales favoritas y más,
					</p>
					<span
						className="temporaryLogin__links"
						onClick={() => openExitModal("login")}
					>
						inicia sesión{" "}
					</span>
					o{" "}
					<span
						className="temporaryLogin__links"
						onClick={() => openExitModal("register")}
					>
						regístrate.
					</span>{" "}
				</div>
			</HeaderTemporary>
		</div>
	);
};

const HeaderTemporary = styled.div`
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	z-index: 100;
	overflow: hidden;
	align-items: center;
	padding: 20px;

	& p {
		margin-bottom: 0;
		color: #000 !important;
	}

	& span {
		font-weight: 300;
	}
	& h3 {
		color: ${(props) =>
			props.isLoggedInTemporary ? props.theme.colors.blue_bg : ""};
		font-weight: normal;
	}
	.temporaryLogin__links {
		color: ${(props) => props.theme.colors.blue_bg};
		font-weight: 600;

		:hover {
			cursor: pointer;
			text-decoration: underline;
		}
	}
`;

const Avatar = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 80px;
	height: 80px;
	overflow: hidden;
	border-radius: 50%;
	box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
	background: ${(props) => {
		return props.isLoggedInTemporary ? props.theme.colors.blue_bg : "";
	}};
`;
